import { IAlphaMiniCartModel } from 'Types/Litium';

const CartItemSummary = ({
    items,
    isLoading,
    translations,
}: {
    items: IAlphaMiniCartModel['orderDetails'];
    isLoading: boolean;
    translations: IAlphaMiniCartModel['translations'];
}) => (
    <ul
        className={`bottom-0 flex w-full flex-col flex-wrap justify-end bg-white transition-opacity duration-layout ${
            isLoading ? 'opacity-50' : 'opacity-100'
        }`}
    >
        <li className="flex flex-wrap items-baseline justify-between">
            <h3 className="text-xl font-semibold">
                {translations.orderTotalInclVatLabel}:
            </h3>
            <span className="text-xl font-semibold">
                {items.orderGrandTotal}
            </span>
        </li>
    </ul>
);

export default CartItemSummary;
